import { render, staticRenderFns } from "./menu-popup.vue?vue&type=template&id=2f5bc049&scoped=true"
import script from "./menu-popup.vue?vue&type=script&lang=js"
export * from "./menu-popup.vue?vue&type=script&lang=js"
import style0 from "./menu-popup.vue?vue&type=style&index=0&id=2f5bc049&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5bc049",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5bc049')) {
      api.createRecord('2f5bc049', component.options)
    } else {
      api.reload('2f5bc049', component.options)
    }
    module.hot.accept("./menu-popup.vue?vue&type=template&id=2f5bc049&scoped=true", function () {
      api.rerender('2f5bc049', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/menu-popup.vue"
export default component.exports